module.exports = __webpack_public_path__ + "static/media/up-arrow.0c1ac00c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ColumnViewFilters/up-arrow.svg
// module id = 1129
// module chunks = 0